/**
 * Fetch comments referenced by a CommentInfo (deep-link from notifications).
 * Mirrors Flutter ContentReactionsRepository.getNotificationComments.
 */

import { CommentService } from '@/domain/services/comment/commentService';
import type { CommentInfoEntity } from '@/domain/entities/comment/commentInfoEntity';
import type { CommentEntity } from '@/domain/entities/comment/commentEntity';

export class FetchNotificationCommentsUseCase {
  constructor(private service = CommentService.getInstance()) {}

  async execute(commentInfo: CommentInfoEntity): Promise<CommentEntity[]> {
    const ids: string[] = [commentInfo.id];
    if (commentInfo.parentId) ids.push(commentInfo.parentId);
    if (commentInfo.replyId) ids.push(commentInfo.replyId);
    return this.service.fetchCommentsByIds(ids);
  }
}

export const fetchNotificationCommentsUseCase = new FetchNotificationCommentsUseCase();
